@let availableLayers = availableLayers$ | async;
@if (availableLayers && availableLayers.length > 0) {
  <mat-form-field appearance="fill">
    <mat-label i18n="@@core.filter.select-layer">Select layer(s)</mat-label>
    <mat-select [formControl]="selectedLayersControl" multiple>
      @for (layer of availableLayers; track layer.id) {
        <mat-option [value]="layer.id">{{layer.title}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}
